<i18n>
{
  "fr": {
    "ProjectsName": "Nom des projets",
    "Velocity": "Vélocité",
    "TasksInError": "Nombre de tâches en erreur"
  }
}
</i18n>

<template>
  <section>
    <table class="table table-bordered table-hover">
      <thead class="thead-dark">
        <tr>
          <th
            v-t="'ProjectsName'"
            scope="col"/>
          <th
            v-t="'Velocity'"
            scope="col"/>
          <th
            v-t="'TasksInError'"
            scope="col"/>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(task, index) in projectsTasks"
          :key="index">
          <td scope="row">{{ task.projectName }}</td>
          <td
            :class="{
              'bg-primary': task.velocity <= 1 && task.velocity >= 0.95,
              'bg-success': task.velocity < 0.95 && task.velocity >= 0.90,
              'bg-warning': task.velocity < 0.90 && task.velocity >= 0.85,
              'bg-danger': task.velocity < 0.85,
            }"
          >{{ task.velocity | percentage }}</td>
          <td
            :class="{ 'bg-danger-light': task.tasksInError > 0 }"
          >{{ task.tasksInError }}</td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('tasks', ['projectsTasks']),
  },
};
</script>
